import { render, staticRenderFns } from "./AllSales.vue?vue&type=template&id=0fa91648&scoped=true&"
import script from "./AllSales.vue?vue&type=script&lang=js&"
export * from "./AllSales.vue?vue&type=script&lang=js&"
import style0 from "./AllSales.vue?vue&type=style&index=0&id=0fa91648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa91648",
  null
  
)

export default component.exports